import { zYesno } from '@/utils';
import { stringLookup } from '@/utils/zodHelper';
import { z } from 'zod';

export const DivisionSchema = z.object({
  id: z.number().optional(),
  name: z.string().optional(),
  translations: z.array(
    z.object({
      id: z.number().optional(),
      name: z.string().max(200),
      language_code: stringLookup().or(z.string()),
      inlineIndex: z.number().optional(),
    }),
  ),
  is_active: z.boolean().optional(),
});

export const DivisionSearchSchema = z.object({
  search: z.string().optional(),
  is_active: zYesno().optional(),
});

export type DivisionSchemaType = z.infer<typeof DivisionSchema>;
